define('shared/remote/offer/validate',[
    '$', 
    'shared/lib/RSVP', 
    'shared/page/language', 
    'shared/page/market', 
    'shared/page/partner', 
    'shared/my/identity', 
    'shared/util/checkout/coupon',
    'shared/initializer/form/constants',
    'shared/util/checkout/checkout'
],
function ($, RSVP, getLanguage, getMarket, getPartner, getIdentity, couponUtil, constants, checkoutUtil) {
    'use strict';

    var URL = '/services/commerce-v4/offermanager/validateoffer';
    var UNIVERSAL_OFFER_ID = 2006;
    var cache = {};

    function getCache() {
        var cur = cache;
        for(var l = arguments.length; l--;) {
            if (!(arguments[l] in cur)) {
                cur[arguments[l]] = {};
            }
            cur = cur[arguments[l]];
        }
        if (cur != null && cur.promise != null) {
            return cur.promise;
        }
        else {
            return null;
        }
    }
    
    function validate(marketCode, partnerCode, languageCode, memberId, couponCode, offerId) {
        var flowType;
        var ret = getCache.apply(this, arguments);

        if (ret == null) {
            ret = RSVP.resolve()
                .then(function(){
                    return checkoutUtil.getCurrentFlowType();
                })
                .then(function(type){
                    flowType = type;
                })
                .then(function(){
                    var offerType = constants.OfferType.Subscription;
                    if(flowType === constants.CheckoutFlowType.Upsell){
                        offerType = constants.OfferType.Upsell;
                    }
                    return new RSVP.Promise(function(resolve, reject){
                        var dfd = $.ajax({
                            url: URL,
                            type: 'GET',
                            dataType: 'json',
                            data: {
                                marketCode: marketCode,
                                partnerCode: partnerCode,
                                cultureCode: languageCode,
                                memberId: memberId,
                                offerId: offerId,
                                couponCode: couponCode,
                                offerType: offerType
                            }
                        }).promise();
                        dfd.then(resolve, reject);
                    });
                });
        }

        return ret;
    }

    /*
        options.id - the offer id
    */
    return function( options ){
        if ( options == null || options.id == null ) {
            throw new Error('No offer id is specified.');
        }

        if(options.id === UNIVERSAL_OFFER_ID){
            return RSVP.resolve();
        }

        return RSVP.resolve()
            .then(function(){
                return RSVP.all([getMarket(), getPartner(), getLanguage(), getIdentity(), couponUtil.get()]);
            })
            .then(function(values){
                values.push( options.id );
                return validate.apply( this, values );
            })
            .then(function(data){
                if ( data.Success !== true ) {
                    return RSVP.reject('Server error or offer cannot pass validation');
                }
            });
    };
});
